// One-time migration banner that surfaces when ClientsProvider (and
// PipelineProvider, eventually) bulk-uploaded localStorage data to
// Supabase on first boot. Lets the user know it happened so they're
// not surprised, and dismissible.

import { useState } from 'react';
import { useClients } from '../../context/ClientsContext';

const DISMISS_KEY = 'bcc_migration_banner_dismissed';

export default function MigrationBanner() {
  const { migrated, migrationCount } = useClients();
  const [dismissed, setDismissed] = useState(() => !!localStorage.getItem(DISMISS_KEY));

  if (!migrated || dismissed) return null;

  return (
    <div className="mb-4 bg-deep-teal/10 border border-deep-teal/30 rounded-[4px] px-4 py-3 flex items-center justify-between text-[12px]">
      <div>
        <div className="font-bold text-deep-teal">Data migrated to the cloud</div>
        <div className="text-[#444]">
          {migrationCount} client{migrationCount !== 1 ? 's' : ''} were uploaded from this browser to Supabase. All edits going forward sync across the team automatically.
        </div>
      </div>
      <button
        onClick={() => { localStorage.setItem(DISMISS_KEY, '1'); setDismissed(true); }}
        className="ml-4 text-[11px] font-bold text-deep-teal hover:underline px-2"
      >
        Got it
      </button>
    </div>
  );
}
